import { ContactForm } from '@rumblefish/ui/Rumblefish23Theme';
import { Link } from '@rumblefish/ui/src/components/Rumblefish23Theme';
import type { ContactProps } from '@rumblefish/ui/src/components/Rumblefish23Theme/Contact/Contact.types';
import React from 'react';

import {
  Subtitle,
  InfoStack,
  ContentStack,
  SubtitleLink,
  StyledWrapper,
  ContactSection,
  StyledFirstTitle,
} from './styles';

export const Contact = ({ id, color }: ContactProps) => {
  return (
    <ContactSection width="normal" borderTopOn id={id}>
      <StyledWrapper>
        <ContentStack>
          <InfoStack>
            <StyledFirstTitle variant="strong_700">
              Ready to start the journey?
              <br />
              Our Startup Consultants will help you
              <br />
              every step of the way!
            </StyledFirstTitle>

            <Subtitle
              variant="regular_500"
              width={{ xs: '100%', md: '50%', xl: '45%' }}>
              Get in touch and let’s start working on your concept to make it
              viable!
            </Subtitle>

            <Subtitle variant="regular_300">
              Do you prefer e-mail?
              <br />
              <Link to={'mailto:hello@rumblefish.com'}>
                <SubtitleLink variant="regular_300">
                  hello@rumblefish.pl
                </SubtitleLink>
              </Link>
            </Subtitle>
          </InfoStack>

          <ContactForm color={color} />
        </ContentStack>
      </StyledWrapper>
    </ContactSection>
  );
};
